import React, { useEffect, useRef } from 'react';

// Recherche « tolérante » : sans accents, sans majuscules, tous les mots doivent être trouvés
// (ex. « securite aws » trouve « Sécurité sur AWS »).
export const normalize = (s) => String(s || '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().replace(/[’']/g, ' ');

export const matches = (query, ...fields) => {
  const words = normalize(query).split(/\s+/).map(w => w.replace(/^#/, '')).filter(Boolean);
  if (!words.length) return true;
  const hay = normalize(fields.filter(Boolean).join(' '));
  return words.every(w => hay.includes(w));
};

// Extrait autour du premier mot trouvé (pour montrer pourquoi un résultat correspond)
export const snippet = (query, text, size = 90) => {
  const words = normalize(query).split(/\s+/).map(w => w.replace(/^#/, '')).filter(Boolean);
  if (!words.length || !text) return '';
  const n = normalize(text);
  let at = -1;
  for (const w of words) { at = n.indexOf(w); if (at >= 0) break; }
  if (at < 0) return '';
  let start = Math.max(0, at - Math.floor(size / 4));
  const sep = text.lastIndexOf(' · ', at);               // commence au début de la carte concernée si possible
  if (sep >= start - size / 2 && sep >= 0 && sep < at) start = sep + 3;
  const end = Math.min(text.length, start + size);
  return `${start > 0 ? '…' : ''}${text.slice(start, end).trim()}${end < text.length ? '…' : ''}`;
};

// Barre de recherche : icône loupe, bouton effacer, touche « / » pour y aller directement
export default function SearchBar({ value, onChange, placeholder, label, count, total, unit = 'résultat' }) {
  const ref = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === '/' && !e.ctrlKey && !e.metaKey && !(e.target.closest && e.target.closest('input, textarea, [contenteditable="true"]'))) {
        e.preventDefault();
        ref.current && ref.current.focus();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const searching = value.trim() !== '';
  return (
    <div className="search-wrap">
      <div className={`search-bar ${searching ? 'active' : ''}`} role="search">
        <svg className="search-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2.2" /><path d="M15.5 15.5L20 20" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>
        <input
          ref={ref}
          type="search"
          value={value}
          onChange={e => onChange(e.target.value)}
          onKeyDown={e => { if (e.key === 'Escape' && value) { e.preventDefault(); onChange(''); } }}
          placeholder={placeholder}
          aria-label={label || placeholder}
          enterKeyHint="search"
          autoComplete="off"
          spellCheck="false"
        />
        {searching
          ? <button type="button" className="search-clear" onClick={() => { onChange(''); ref.current && ref.current.focus(); }} aria-label="Effacer la recherche">✕</button>
          : <kbd className="search-kbd" aria-hidden="true">/</kbd>}
      </div>
      {searching && (
        <p className="search-count" role="status" aria-live="polite">
          {count === 0 ? 'aucun résultat' : `${count} ${unit}${count > 1 ? 's' : ''}`} sur {total}
        </p>
      )}
    </div>
  );
}
